import { Pipe, PipeTransform } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";
import { EMPTY, Observable, timer } from "rxjs";
import { map, takeWhile } from "rxjs/operators";

//https://gist.github.com/craigiswayne/f3ebe749c4023d345aedccc47120bf02

@Pipe({
	name: "countdown_custom_format",
	standalone: false
})
export class CountdownCustomFormatPipe implements PipeTransform {
	private isDays = false;

	constructor(private translationService: TranslationService) {}

	// get difference in milliseconds
	private getMsDiff = (futureDate: number): number => futureDate - Date.now();

	// covert milliseconds to time
	private msToTime(msRemaining: number): string | null {
		if (msRemaining < 0) {
			console.warn("No Time Remaining:", msRemaining);
			return null;
		}

		let seconds: string | number = Math.floor((msRemaining / 1000) % 60);
		let minutes: string | number = Math.floor((msRemaining / (1000 * 60)) % 60);
		let hours: string | number = Math.floor((msRemaining / (1000 * 60 * 60)) % 24);
		const days: string | number = Math.floor((msRemaining / (1000 * 60 * 60 * 24)) % 24);

		seconds = seconds < 10 ? "0" + seconds : seconds;
		minutes = minutes < 10 ? "0" + minutes : minutes;
		hours = hours < 10 ? "0" + hours : hours;

		if (days > 0) {
			let suffix = "";
			const day = days.toString();
			if (days > 1) {
				//more than 1 day
				suffix = this.translationService.translate("days");
			} else {
				//1 day
				suffix = this.translationService.translate("day");
			}
			this.isDays = true;

			return day + " " + suffix;
		}

		return `${hours}:${minutes}:${seconds}`;
	}

	// input can be raw date string or date string with timezone
	public transform(futureDate: number): Observable<string> {
		if (!futureDate || this.getMsDiff(futureDate) < 0) {
			return EMPTY;
		}

		return timer(0, 1000).pipe(
			map(() => this.msToTime(this.getMsDiff(futureDate))),
			takeWhile(this.checkIfCountdownIsComplete, true)
		);
	}

	// stop subscription if countdown is complete
	private checkIfCountdownIsComplete = (timeDifference: string): boolean => {
		if (this.isDays) {
			return true;
		}

		const _temp = timeDifference.split(":");
		const test = +_temp[0] > 0 || +_temp[1] > 0 || +_temp[2] > 0;
		return test;
	};
}
